import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TaskPane } from "./components/TaskPane";
import "./index.css";

Office.onReady((info) => {
  const root = document.getElementById("root");
  if (!root) throw new Error("Root element not found");

  if (info.host === Office.HostType.Outlook || !info.host) {
    // Renders in Outlook and in browser (for testing)
    createRoot(root).render(
      <StrictMode>
        <TaskPane />
      </StrictMode>
    );
  } else {
    root.textContent = "Lio ist nur in Outlook verfügbar.";
  }
});
